module.exports = __webpack_public_path__ + "static/media/logo.88dee20a.jpg";